import { createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";

const initialState = {
  isAuthenticated: false,
  token: null,
  isLoading: false,
  error: null,
  doneQuestionaire: false,
  receipts: [],
  vouchers: [],
  user: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    saveUser: (state, action) => {
      // console.log(action.payload);
      return {
        ...state,
        user: action.payload,
        isAuthenticated: true,
      };
    },
    logoutUser: (state, action) => {
      Cookies.remove("user-token");
      localStorage.removeItem("done-questionaire");
      return {
        ...state,
        isAuthenticated: false,
        token: null,
        user: null,
      };
    },
    savePoints: (state, action) => {
      return {
        ...state,
        points: action.payload,
      };
    },
    saveReceipts: (state, action) => {
      return {
        ...state,
        receipts: action.payload,
      };
    },
    saveVouchers: (state, action) => {
      return {
        ...state,
        vouchers: action.payload,
      };
    },
    saveToken: (state, action) => {
      Cookies.set("user-token", action.payload, { expires: 14 });
      return {
        ...state,
        token: action.payload,
        isAuthenticated: true,
      };
    },
    saveQuestionaireStatus: (state, action) => {
      localStorage.setItem("done-questionaire", action.payload);
      return {
        ...state,
        doneQuestionaire: action.payload,
      };
    },
  },
});

export const {
  saveStore,
  saveUser,
  logoutUser,
  savePoints,
  saveToken,
  saveStores,
  saveReceipts,
  saveVouchers,
  saveQuestionaireStatus,
} = userSlice.actions;
export default userSlice.reducer;
